import { refreshToken } from "./nimble";

let token = null;
let refAuthID = null;
let urlInfo = null;
let refreshTimer = null;

export function setToken(newToken, minutesToExpire, newRefAuthID, url) {
  token = newToken;
  refAuthID = newRefAuthID;
  urlInfo = url;
  scheduleRefresh(minutesToExpire);
}

export function getToken() { 
  return token;
}

function scheduleRefresh(minutesToExpire) {
  if (refreshTimer) clearTimeout(refreshTimer);

  const refreshInMs = Math.max((minutesToExpire - 2) * 60 * 1000, 0);

  refreshTimer = setTimeout(async () => {
    const result = await refreshToken(token, refAuthID ,urlInfo);

    if (result) {
      setToken(result.token, result.minutesToExpire, result.refAuthID ,urlInfo);
    }
  }, refreshInMs);
}
